import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldAi: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShieldAi"><Path d="M3.5 5.5L12 2L20.5 5.5V13C20.5 17.6944 16.6944 21.5 12 21.5C7.30558 21.5 3.5 17.6944 3.5 13V5.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M12.4 7.9541H11.6L10.6 10.5541L8 11.5541V12.3541L10.6 13.3541L11.6 15.9541H12.4L13.4 13.3541L16 12.3541V11.5541L13.4 10.5541L12.4 7.9541Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconShieldAi;
